import React, { useEffect, useState, Fragment } from 'react'
import { Carousel } from 'react-responsive-carousel'
import { getUrlFromAStream } from '../../../../utils/getUrlByFileStream'
import { NoInfo } from '../../../common/NoInfo'
import ReactPlayer from 'react-player/youtube'
import { articlesApi } from '../../../../api/articlesApi'
import _ from 'lodash'
import 'react-responsive-carousel/lib/styles/carousel.min.css' // requires a loader

const ViewVideoOrImgs = (
    {
        buttonViewImg,
        itemSelected,
    }
) => {

    const [allProductImages, setAllProductImages] = useState([])

    const filterProductsImages = async (itemSelected) => {
        if (!_.isEmpty(itemSelected)) {
            let getAllProductsThatHaveImg = await articlesApi.getArticleImgs(itemSelected.id_Articulo)
            let allUrlImg = []
            for (let img in getAllProductsThatHaveImg.data) {
                const url = await getUrlFromAStream(getAllProductsThatHaveImg.data[img].ruta, 'application/image')
                allUrlImg.push(url)
            }
            setAllProductImages(allUrlImg)
        }
    }

    useEffect(() => {
        filterProductsImages(itemSelected)
    }, [itemSelected])

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                aspectRatio: '16/9',
                maxWidth: '100%',
                boxSizing: 'border-box'
            }}
        >
            {buttonViewImg 
                ? <Fragment>
                        {
                            allProductImages.length > 0 ?
                                <Carousel autoPlay thumbWidth={'100%'}>
                                    {
                                         allProductImages.map((url, i) =>
                                            <div key={ i }>
                                                <img alt="img" src={url} style={{ width: '100%', height: '100%', objectFit: 'contain', aspectRatio: '16/9' }} />
                                            </div>
                                        )
                                    }
                                </Carousel>
                            : NoInfo("No hay imágenes")
                        }
                    </Fragment>
                :
                    <Fragment>
                        {
                            itemSelected.link !== ''  || null ? 
                                <div className="product-detail__video" style={{ width: '100%', height: '100%', aspectRatio: '16/9' }}>
                                    <ReactPlayer url={itemSelected.link} controls width="100%" height="100%"  />
                                </div>
                            :  NoInfo("No hay vídeo")
                        }
                    </Fragment>
            }
        </div>
    )
}
export default ViewVideoOrImgs